// components/layout/BrandSwitcher.jsx
import React, { useState } from 'react';
import { Icon } from '../ui/Icon';
import { BRANDS } from '../../config/brands';
import { useBrand } from '../../contexts/BrandContext';

export function BrandSwitcher({ visible, onToggle }) {
  const { brand, brandId, setBrandId } = useBrand();
  const [open, setOpen] = useState(false);
  
  if (!visible) return null;
  
  return (
    <div style={{ 
      position: 'fixed', 
      top: 24, 
      left: 24, 
      zIndex: 9999 
    }}>
      <button
        onClick={() => setOpen(!open)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          padding: '12px 16px',
          background: 'white',
          border: '2px solid #E5E7EB',
          borderRadius: 12,
          cursor: 'pointer',
          boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
          transition: 'all 0.2s',
          fontFamily: 'Libre Franklin, sans-serif'
        }}
      >
        <div style={{
          width: 28,
          height: 28,
          borderRadius: 6,
          background: brand.logo ? 'transparent' : brand.c.headerBg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden'
        }}>
          {brand.logo ? (
            <img src={brand.logo} alt={brand.name} style={{ width: 28, height: 28, objectFit: 'contain' }} />
          ) : (
            <Icon name="shield" size={14} color={brand.c.gold} />
          )}
        </div>
        <div style={{ textAlign: 'left' }}>
          <div style={{ 
            fontSize: 11, 
            fontWeight: 800,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            color: '#6B7280',
            marginBottom: 2
          }}>
            Brand Demo
          </div>
          <div style={{ 
            fontSize: 13, 
            fontWeight: 700,
            color: '#111827'
          }}>
            {brand.name}
          </div>
        </div>
        <Icon 
          name="chevDown" 
          size={16}
          style={{ 
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.2s'
          }}
        />
      </button>
      
      {open && (
        <div style={{
          position: 'absolute',
          left: 0,
          top: 'calc(100% + 8px)',
          background: 'white',
          borderRadius: 12,
          boxShadow: '0 16px 48px rgba(0,0,0,0.18)',
          border: '1px solid #E5E7EB',
          width: 320,
          overflow: 'hidden',
          animation: 'scaleIn 0.2s ease-out'
        }}>
          <div style={{ 
            padding: '14px 16px', 
            background: '#F9FAFB',
            borderBottom: '1px solid #F3F4F6'
          }}>
            <p style={{ 
              fontSize: 11, 
              fontWeight: 800,
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              color: '#6B7280',
              margin: 0
            }}>
              Switch Brand
            </p>
          </div>
          
          {Object.values(BRANDS).map(b => (
            <button
              key={b.id}
              onClick={() => {
                setBrandId(b.id);
                setOpen(false);
              }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                width: '100%',
                padding: '14px 16px',
                border: 'none',
                cursor: 'pointer',
                textAlign: 'left',
                background: brandId === b.id ? b.c.blueLight : 'transparent',
                borderLeft: brandId === b.id ? `3px solid ${b.c.accent}` : '3px solid transparent',
                transition: 'all 0.2s',
                fontFamily: 'Libre Franklin, sans-serif'
              }}
              onMouseEnter={(e) => {
                if (brandId !== b.id) {
                  e.currentTarget.style.background = '#F9FAFB';
                }
              }}
              onMouseLeave={(e) => {
                if (brandId !== b.id) {
                  e.currentTarget.style.background = 'transparent';
                }
              }}
            >
              <div style={{
                width: 40,
                height: 40,
                borderRadius: 8,
                background: b.logo ? 'transparent' : b.c.headerBg,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                overflow: 'hidden'
              }}>
                {b.logo ? (
                  <img src={b.logo} alt={b.name} style={{ width: 40, height: 40, objectFit: 'contain' }} />
                ) : (
                  <Icon name="shield" size={18} color={b.c.gold} />
                )}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ 
                  fontSize: 14, 
                  fontWeight: 700,
                  color: '#111827',
                  marginBottom: 2
                }}>
                  {b.name}
                </div>
                <div style={{ 
                  fontSize: 11, 
                  color: '#6B7280',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}>
                  {b.tagline}
                </div>
              </div>
              {brandId === b.id && (
                <Icon name="checkCircle" size={18} color={b.c.accent} />
              )}
            </button>
          ))}
          
          <div style={{ 
            padding: '12px 16px', 
            background: '#F9FAFB',
            borderTop: '1px solid #F3F4F6',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <span style={{ fontSize: 11, color: '#6B7280' }}>
              White-label demo tool
            </span>
            <button
              onClick={() => {
                onToggle();
                setOpen(false);
              }}
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: brand.c.accent,
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontFamily: 'Libre Franklin, sans-serif'
              }}
            >
              Hide Switcher
            </button>
          </div>
        </div>
      )}
      
      <style>{`
        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
      `}</style>
    </div>
  );
}
